











































































import { Component, Prop, PropSync, Ref, Vue } from 'vue-property-decorator';
import PopupCard from './PopupCard.vue';
import DraggableEvent from './DraggableEvent.vue';
import MonthlyCalendarDayArea from './MonthlyCalendarDayArea.vue';
import MoreShiftsPopup from './MoreShiftsPopup.vue';
//@ts-ignore
import { shiftDataStore } from '@/store/theoryApiStore/shiftDataModule.ts';

@Component({
  components: {
    PopupCard,
    DraggableEvent,
    MonthlyCalendarDayArea,
    MoreShiftsPopup
  }
})
export default class Calendar extends Vue {
  private eventSummaryFormat(event: any): string {
    return `${event.start.getHours()}:${`00${event.start.getMinutes()}`.slice(-2)} ${event.name}`
  }
  @PropSync('focusValue', {type: String, required: true})
  public focus!: string;
  public type: string = 'month';
  public typeToLabel: {[key: string]: string} = {
    'month': 'Month',
    'week': 'Week',
    'day': 'Day',
    '4day': '4 Days'
  }
  public selectedEventId?: string;
  public selectedElement: any = null
  public selectedOpen: boolean = false;

  public createdEventId?: string;

  public isEventCreating: boolean = false;

  public colors: Array<string> = ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'];
  public names: Array<string> = ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'];

  private isMenuPositionLeft: boolean = true;
  private isMenuPositionRight: boolean = false;
  private nudgeWidth: number = 0;
  private isCloseButtonOnShiftMenuClicked: boolean = false;

  private calendarAreaHeight: number = 400;

  private isMoreShiftPopupOpen: boolean = false;
  private moreShiftPopupActivator?: HTMLElement | null;
  private moreShiftPopupYear?: number = 1990;
  private moreShiftPopupMonth?: number = 1;
  private moreShiftPopupDay?: number = 1;
  private moreShiftPopupWidth: number = 0;
  private isHideWhenShiftMenuOpen: boolean = false;

  @Ref() morePopup!: any;

  get events() {
    return shiftDataStore.temporaryEventsForCalendar;
  }

  get eventsInDate() {
    return (year: number, month: number, day: number) => {
      return shiftDataStore.eventsForCalendar.filter((event: any) => {
        return event.start.getFullYear() === year && event.start.getMonth() === month-1 && event.start.getDate() === day;
      }).sort((left: any, right: any) => {
        if(left.start.getTime() > right.start.getTime()) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }


  private calcCalendarAreaHeight() {
    const windowHeight = window.innerHeight;
    const commonHeaderHeight = 55;
    const shiftHeaderHeight = 64;
    this.calendarAreaHeight = windowHeight - commonHeaderHeight - shiftHeaderHeight - 60;
  }

  private weekdayFormat(event: any) {
    const weekdayChar = ["日", "月", "火", "水", "木", "金", "土"];
    return weekdayChar[event.weekday];
  }

  private dayFormat(event: any) {
    return event.day === 1 ? `${` ${event.month}`.slice(-2)}月${` ${event.day}`.slice(-2)}日` : event.day;
  }

  private monthFormat(event: any) {
    return "";
  }

  @Prop({type: Function, required: true})
  public updateTitle!: () => void;

  dragEvent: any = null;
  dragStart: any = null;
  dragTime: any = null;
  createEvent: any = null;
  createStart: any = null;
  extendOriginal: any = null;

  public mounted() {
    (this.$refs.calendar as any).checkChange()
    this.calcCalendarAreaHeight();
    window.addEventListener('resize', this.calcCalendarAreaHeight)
  }
  public beforeDestroy() {
    window.removeEventListener('resize', this.calcCalendarAreaHeight)
  }
  @Prop({type: Function, required: true})
  public viewWeek!: ({ date }: {date: string}) => void;

  @Prop({type: Function, required: true})
  public gotoCertainDate!: ({ date }: {date: string}) => void;

  public getEventColor(event: any) {
    return event.color
  }
  public setToday() {
    this.focus = ''
  }
  public prev() {
    (this.$refs.calendar as any).prev()
  }
  public next() {
    (this.$refs.calendar as any).next()
  }
  public checkChange() {
    (this.$refs.calendar as any).checkChange()
  }
  public get calendarTitle() {
    if (!this.$refs.calendar) return "";

    const calendar = (this.$refs.calendar as any)
    if (calendar.lastStart.year !== calendar.lastEnd.year) {
      return `${calendar.lastStart.year}年 ${calendar.lastStart.month}月 〜 ${calendar.lastEnd.year}年 ${calendar.lastEnd.month}月`
    } else if (calendar.lastStart.month !== calendar.lastEnd.month) {
      return `${calendar.lastStart.year}年 ${calendar.lastStart.month}月 〜 ${calendar.lastEnd.month}月`
    } else {
      return `${calendar.lastStart.year}年 ${calendar.lastStart.month}月`
    }
  }
  private clickCloseShiftMenuButton() {
    this.isCloseButtonOnShiftMenuClicked = true;
    this.hideShiftMenu(true);
  }
  public showShiftMenu(eventId: string, element?: Element) {
    const open = () => {
      // if (this.isMoreShiftPopupOpen) {
      //   this.isHideWhenShiftMenuOpen = true;
      // }
      shiftDataStore.updateEvent({
        eventId,
        temporary: true
      })
      // shiftDataStore.sortShifts();
      const event = shiftDataStore.getSingleEventForCalendar(eventId);
      const domElement = element || document.querySelector(`[data-is-temporary="true"]`);
      this.selectedElement = domElement;
      this.selectedEventId = eventId;
      this.nudgeWidth = domElement!.clientWidth;
      const rect = event.monthlyDom.getBoundingClientRect()
      const spaceWidth = rect.left + window.pageXOffset;
      if (spaceWidth < 400) {
        this.isMenuPositionLeft = false;
        this.isMenuPositionRight = true;
      } else {
        this.isMenuPositionLeft = true;
        this.isMenuPositionRight = false;
      }
      console.log(this.selectedElement, this.isMenuPositionLeft, this.isMenuPositionRight, this.nudgeWidth)
      this.selectedOpen = true
    }
    if (this.selectedOpen) {
      this.selectedOpen = false
      setTimeout(open, 10)
    } else {
      setTimeout(open, 10)
    }

  }
  public updateRange({ start, end }: { start: any, end: any }) {
    // 表示月や表示範囲が変わった際に発火されるイベントの実実装部分。現時点では必要ではないため空の関数。
  }

  toTime (tms: any) {
    return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
  }
  roundTime (time: any, down: boolean = true) {
    const roundTo = 15 // minutes
    const roundDownTime = roundTo * 60 * 1000

    return down
      ? time - time % roundDownTime
      : time + (roundDownTime - (time % roundDownTime))
  }
  async createEventInDay(times: any) {
    // 一旦9時-10時で作成されるように実装
    if (this.selectedOpen) {
      this.hideShiftMenu(true);
    }
    this.isEventCreating = true;
    const start = new Date(times.year, times.month - 1, times.day, 9, 0);
    const end = new Date(times.year, times.month - 1, times.day, 10, 0);
    const eventId = await shiftDataStore.addShiftAction({
      start,
      end
    });
    this.createdEventId = eventId;
    shiftDataStore.sortShifts();
    this.showShiftMenu(eventId);
  }
  clickEvent(eventId: string, element: Element) {
    this.hideShiftMenu(true);
    this.showShiftMenu(eventId, element);

  }
  public hideShiftMenu(isDeleteCreatedShift: boolean = false) {
    console.log("hide");
    this.selectedOpen = false;
    shiftDataStore.updateEvent({
      eventId: this.selectedEventId,
      temporary: false
    })
    this.selectedElement = undefined;
    if (this.createdEventId && isDeleteCreatedShift) {
      shiftDataStore.deleteShift({
        eventId: this.createdEventId
      });

    }
    this.createdEventId = undefined;
    this.selectedEventId = undefined;
    shiftDataStore.sortShifts();
  }
  public clickOnOutsideOfPopup(e: boolean) {
    if (!e) {
      this.hideShiftMenu();
    }
  }
  public onClickDayNumber({ date }: {date: string}) {
    if (this.selectedOpen) {
      this.hideShiftMenu()
    } else {
      this.viewWeek({ date });
    }
  }
  public changeActivator() {
    const targetEvent = shiftDataStore.getSingleEventForCalendar(this.selectedEventId!);
    (this.$refs.calendar as any).move(targetEvent.start.getMonth() + 1 - (this.$refs.calendar as any).lastStart.month);
    this.showShiftMenu(this.selectedEventId!);
  }
  private showMore(element: Element, year: number, month: number, day: number) {
    // console.log(element.parentElement)
    const open = () => {
      this.moreShiftPopupYear = year;
      this.moreShiftPopupMonth = month;
      this.moreShiftPopupDay = day;
      this.moreShiftPopupActivator = element.parentElement;
      this.moreShiftPopupWidth = element.parentElement?.clientWidth! + 40
      this.isMoreShiftPopupOpen = true;
    }
    if (this.isMoreShiftPopupOpen) {

      this.closeMoreShiftsPopup();
    }
    setTimeout(open, 10);

  }
  private clickOnOutsideOfMoreShiftsPopup(e: any) {
    console.log("close")

    if (this.selectedOpen || this.isCloseButtonOnShiftMenuClicked) {
      this.isCloseButtonOnShiftMenuClicked = false;
      return ;
    }if (!e.srcElement.closest(".more-shift-popup-base")) {
      this.closeMoreShiftsPopup();
    }
  }
  private closeMoreShiftsPopup() {
    this.isMoreShiftPopupOpen = false;
    this.moreShiftPopupActivator = undefined;
  }
}
